import React, { useState, useEffect, useCallback } from "react";
import { Card } from "react-bootstrap";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import { useHistory, useParams } from "react-router-dom";

import toastr from "toastr";
// import EmployeeForm from "./Component/EmployeeForm";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import ContractorPersonForm from "./Component/ContractorPersonForm";
import { getContractor } from "app/_services/Contractor/ContractorService";
import {
  getContractorPersonById,
  updateContractorPersonBasicDetails,
} from "app/_services/UserManagement/ContractorPersonService";
// import toastr from "toastr";
import {
  ContractorPersonActions,
  contractorPersonExtraToChange,
  contractorPersonValidation,
  initialContractorPersonForm,
} from "./Constant";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { WidgetBox, preTrainingValidation } from "../Employee/Constant";

function EditContractorPerson() {
  const [form, setForm] = useState({ ...initialContractorPersonForm });
  const [error, setError] = useState({});
  const [previousTraining, setPreviousTraining] = useState([]);
  const [preTrainingErr, setPreTrainingErr] = useState([]);

  const [siteList, setSiteList] = useState([]);
  const [contractorList, setContractorList] = useState([]);

  const { push } = useHistory();
  const { id } = useParams();

  const onChange = useCallback(
    async ({ target: { name, value, type, checked } }) => {
      if (name === "aadharNumber") {
        let response = await CommmonService.aadharCheck({
          id,
          aadharNumber: value,
          moduleName: "ContractorPerson",
        });
        if (!response?.status) {
          setError((prev) => ({
            ...prev,
            aadharNumber:
              "This AAdhar Number is already used by " +
              response.data?.firstName +
              " " +
              response.data?.middleName +
              " " +
              response.data?.lastName,
          }));
        } else {
          setError((prev) => ({
            ...prev,
            aadharNumber: "",
          }));
        }
      }
      let extraToChange = contractorPersonExtraToChange(name, value, siteList, form);

      setForm((prev) => ({
        ...prev,
        ...extraToChange,
        [name]: type === "checkbox" ? checked : value,
      }));
    },
    [form, siteList]
  );

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      let errorObj = contractorPersonValidation(form, siteList);

      setError((prev) => ({ ...errorObj }));

      let isPreTraErr =
        previousTraining?.length && form.siteType === 3
          ? preTrainingValidation(previousTraining, setPreTrainingErr)
          : "";

      // if (form.aadharNumber.length === 12) {
      //   let response = await CommmonService.aadharCheck({
      //     id,
      //     aadharNumber: form.aadharNumber,
      //     moduleName: "ContractorPerson",
      //   });
      //   if (!response?.status) {
      //     setError((prev) => ({
      //       ...prev,
      //       ...errorObj,
      //       aadharNumber:
      //         "This AAdhar Number is already used by " +
      //         response.data?.firstName +
      //         " " +
      //         response.data?.middleName +
      //         " " +
      //         response.data?.lastName,
      //     }));
      //   } else {
      //     setError((prev) => ({ ...prev, ...errorObj }));
      //   }
      // } else {
      //   setError((prev) => ({
      //     ...prev,
      //     ...errorObj,
      //     aadharNumber: "Aadhar Number should be of 12 digit",
      //   }));
      // }

      if (isPreTraErr || Object.values(errorObj).filter((d) => d !== "").length) return;

      let duplicateFlag = 0;
      let duplicateData = [];
      if (previousTraining?.length && form.siteType === 3) {
        previousTraining.forEach((d) => {
          if (duplicateData.includes(+d.trainingDesignation)) duplicateFlag++;
          else !d.deleted && duplicateData.push(+d.trainingDesignation);
        });
      }
      if (duplicateFlag) {
        toastr.error(
          "Training Designation should not duplicate in Previous Training Record."
        );
        return;
      }

      let response = await updateContractorPersonBasicDetails(id, {
        contractorPersonData: {
          ...form,
          previousTrainingData: form.siteType === 3 ? previousTraining : [],
        },
      });

      if (!response?.status) {
        // if (response?.message === "This Aadhar Number Already exits.") {
        //   setError((prev) => ({
        //     ...prev,
        //     ...errorObj,
        //     aadharNumber:
        //       "This AAdhar Number is already used by " +
        //       response.data?.firstName +
        //       " " +
        //       response.data?.middleName +
        //       " " +
        //       response.data?.lastName,
        //   }));
        // }
        return toastr.error(response?.message);
      }
      toastr.success(response.message || "Success.");
      push(`/user-management/contractor-person`);
    },
    [form, id, previousTraining, push, siteList]
  );
  const history = useHistory();
  useEffect(() => {
    if (!id) return;

    getContractorPersonById(id).then((response) => {
      if (!response?.status) {
        history.push("/user-management/contractor-person");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      const contractorPersonData = response.data || {};

      setForm({
        ...contractorPersonData,
        siteType: contractorPersonData?.ehsSite?.siteType || "",
        designationChangeTrainingDate:
          contractorPersonData?.designationChangeTrainingDate || "",
        dateOfJoining: contractorPersonData?.dateOfJoining || "",
        dateOfSeparation: contractorPersonData?.dateOfSeparation || "",
        isPmeDate: contractorPersonData?.lastPMEDate ? true : false,
        isIMEDate: contractorPersonData?.isIMEDate ? true : false,
        pmeDate: contractorPersonData?.lastPMEDate,
        imeDate: contractorPersonData?.lastIMEDate,
        certificateFile: {
          imeCertificateId: contractorPersonData?.imefile || null,
          pmeCertificateId: contractorPersonData?.pmefile || null,
        },
      });
      setPreviousTraining(contractorPersonData?.previousTrainingData || []);
    });
  }, [id, siteList]);

  const getAllSiteList = async () => {
    let response = await getAllSites("filter[status]=1&filter[activeStatus]=active");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  };

  const getAllContractorList = async () => {
    let response = await getContractor();
    if (!response?.data || !response?.status) return;

    setContractorList(response.data);
  };

  /**************UseEffect **********/
  useEffect(() => {
    getAllSiteList();
    getAllContractorList();
  }, []);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "User Management", path: "#" },
          {
            name: "Contractor Staff",
            path: "/user-management/contractor-person",
          },
          { name: `Edit`, path: "#" },
        ]}
      />

      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title justify-content-between">
            <h3 class="text-capitalize mb-1">Edit Contractor Staff</h3>
            <ContractorPersonActions id={id} form={form} />
          </Card.Title>
          <WidgetBox form={form} />

          <ContractorPersonForm
            id={id}
            siteList={siteList}
            contractorList={contractorList}
            form={form}
            onChange={onChange}
            error={error}
            previousTraining={previousTraining}
            setPreviousTraining={setPreviousTraining}
            preTrainingErr={preTrainingErr}
          />

          <FormBtn
            id={id}
            onSubmit={onSubmit}
            backUrl={"/user-management/contractor-person"}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default EditContractorPerson;
